import { render } from "./AssetsFilter.vue?vue&type=template&id=b205c8ba"
import script from "./AssetsFilter.vue?vue&type=script&lang=js"
export * from "./AssetsFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__